// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RobotOutlinedSvg from "@ant-design/icons-svg/es/asn/RobotOutlined";
import AntdIcon from '../components/AntdIcon';

var RobotOutlined = function RobotOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RobotOutlinedSvg
  }));
};

RobotOutlined.displayName = 'RobotOutlined';
export default /*#__PURE__*/React.forwardRef(RobotOutlined);